import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('jobPackagesWeight', jobPackagesWeight);

function jobPackagesWeight(splitService) {
  return function jobPackagesWeightFilter(packages, enableSuffix) {
    let itemsWeightSum;
    let hasAnyWeight = false;
    const weightConfig = splitService.getShortWeightUnit();

    itemsWeightSum = _.reduce(packages, function (sum, p) {
      if (!_.isUndefined(p?.weight)) {
        hasAnyWeight = true;
      }
      return sum + _.get(p, 'weight', 0);
    }, 0);

    let decimalNumber: number = Number.isSafeInteger(itemsWeightSum) ? 0 : 2;

    return enableSuffix ? `${itemsWeightSum.toFixed(decimalNumber)} ${weightConfig}` : itemsWeightSum.toFixed(decimalNumber);
  }
}
